// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Cart / Checkout
// The flat delivery fee added to every order (₹). Checkout waives it when the customer's welcome coupon applies
// (pages/Checkout.tsx); the cart panel shows it in the bill summary so the two never disagree.
// ─────────────────────────────────────────────────────────────────────────────
export const DELIVERY_FEE = 60;
